import Swal from 'sweetalert2';

import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';

import SpotifyIcon from '../icons/spotify.svg';

import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed.js';

export default class Spotify extends Plugin {
    static get requires() {
        return [MediaEmbed];
    }

    init() {
        const editor = this.editor;

        editor.ui.componentFactory.add('spotify', (locale) => {
            const view = new ButtonView(locale);

            view.set({
                label: 'Coloque a URL do Spotify',
                icon: SpotifyIcon,
                tooltip: true,
            });

            // Callback executed once the image is clicked.
            view.on('execute', async () => {
                const { value: url } = await Swal.fire({
                    input: 'text',
                    inputPlaceholder: 'Coloque a URL do Spotify',
                });

                if (url) {
                    editor.model.change(() => {
                        const content = ` <p>[template="spotify" url="${url}"]</p>`;

                        const viewFragment = editor.data.processor.toView(content);
                        const modelFragment = editor.data.toModel(viewFragment);

                        editor.model.insertContent(
                            modelFragment,
                            editor.model.document.selection
                        );
                    });
                }
            });

            return view;
        });
    }
}
